import { t } from 'i18next'
import { validateBIC as validateBICTools, extractBIC, ValidationErrorsBIC } from 'ibantools'

import { getIBANCountry } from '@lib/validators/iban'

export const getBICCountry = (bic: string) => {
  const extracted = extractBIC(bic)
  return extracted?.countryCode
}

export const validateBIC = (value: string): string | undefined => {
  const validation = validateBICTools(value)

  if (!validation.valid) {
    if (validation.errorCodes.includes(ValidationErrorsBIC.WrongBICFormat)) {
      return t('subscription.sepa.bicInvalid')
    }
    return t('subscription.sepa.bicInvalid')
  }

  return undefined
}

export const validateBICConsistency = (bic: string, iban: string): string | undefined => {
  const ibanCountry = getIBANCountry(iban)
  const bicCountry = getBICCountry(bic)

  if (bicCountry !== ibanCountry) {
    return t('subscription.sepa.bicCountryMismatch')
  }

  return undefined
}
